import { useState } from 'react';
import axios from 'axios';
import { toast } from 'sonner';
import { Dialog, DialogContent, DialogHeader, DialogTitle } from '../ui/dialog';
import SignatureCanvas from '../SignatureCanvas';
import { API_CP, erreur, nomComplet } from './constantes';

// Pour un participant sans signature enregistrée (ou une personne extérieure) : signature sur l'écran du centre
export const SignatureEcranDialog = ({ participant, annee, onClose, onSigne }) => {
  const [envoi, setEnvoi] = useState(false);
  const signer = async (signature) => {
    setEnvoi(true);
    try {
      const { data } = await axios.post(`${API_CP(annee)}/participants/${participant.participant_id}/signature`, { signature });
      toast.success('Signature enregistrée');
      onSigne(data);
    } catch (e) {
      erreur(e, 'Signature impossible');
    } finally {
      setEnvoi(false);
    }
  };
  return (
    <Dialog open={!!participant} onOpenChange={(o) => !o && onClose()}>
      <DialogContent className="max-w-lg" data-testid="cp-signature-dialog">
        <DialogHeader><DialogTitle>Signature de {nomComplet(participant)}</DialogTitle></DialogHeader>
        {participant && <SignatureCanvas onSave={signer} onCancel={onClose} loading={envoi} buttonText="Enregistrer la signature" />}
      </DialogContent>
    </Dialog>
  );
};
